import { Handle, Position } from '@xyflow/react';

const PendingConnectionNode = () => (
    <Handle
        type="target"
        position={Position.Left}
        isConnectable={false}
        style={{
            width: 1,
            height: 1,
            minWidth: 1,
            minHeight: 1,
            border: 0,
            background: 'transparent',
            opacity: 0,
            pointerEvents: 'none',
        }}
    />
);

export default PendingConnectionNode;